import { AskPiersButton } from "../Assistant/PiersAssistant";
import React from "react";
import { Link } from "react-router-dom";
import { useContextualHelp } from "../Help/ContextualHelp";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import logo from "../../assets/images/piers-sidebar-logo.png";
import "./FullScreenPageLayout.scss";

// Opt in with layout: "full-screen" on the route.
export default function FullScreenPageLayout({
  title,
  subtitle,
  breadcrumbs = [],
  actions,
  showAskPiers = true,
  showUserInfo = false,
  steps,
  className = "",
  children,
}) {
  const { openHelp } = useContextualHelp();
  return (
    <div className={`full-screen-page ${className}`}>
      <header className="full-screen-page__header">
        <Link
          className="full-screen-page__brand"
          to="/inspections/overview"
          aria-label="PIERS home"
        >
          <img src={logo} alt="" />
          <span>
            <strong>PIERS</strong>
            <small>Inspection Platform</small>
          </span>
        </Link>
        <div className="full-screen-page__heading">
          <nav aria-label="Breadcrumb">
            <ol>
              {breadcrumbs.map((item, index) => (
                <li key={`${item.label}-${index}`}>
                  {item.to ? (
                    <Link to={item.to}>{item.label}</Link>
                  ) : (
                    <span aria-current="page">{item.label}</span>
                  )}
                </li>
              ))}
            </ol>
          </nav>
          {title && <h1>{title}</h1>}
          {subtitle && <p>{subtitle}</p>}
        </div>
        <div className="full-screen-page__actions">
          {showAskPiers && <AskPiersButton />}
          {actions}
          <button type="button" onClick={openHelp}>
            <i className="bx bx-help-circle" /> Help
          </button>
          {showUserInfo && <ProfileMenu displayOnly />}
        </div>
      </header>
      {steps && <div className="full-screen-page__steps">{steps}</div>}
      <main className="full-screen-page__content">{children}</main>
    </div>
  );
}
